import type React from "react";
import { ReactComponent as Svg } from "./assets/view-off.svg";
import * as styles from "./Icon.module.scss";

type ViewOffProps = React.SVGProps<SVGSVGElement>;

export const ViewOff = ({ className, ...props }: ViewOffProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
